import api from './api';

export interface ArtifactTypeField {
  name: string;
  label: string;
  type: string;
  required?: boolean;
  description?: string;
  placeholder?: string;
  options?: Array<{value: string, label: string}>;
  depends_on?: {
    field: string;
    value: string | number | boolean;
  };
}

export interface ArtifactTypeSchema {
  fields: ArtifactTypeField[];
}

export interface ArtifactType {
  id: string;
  name: string;
  description: string;
  icon: string;
  viewer: string;
  schema: ArtifactTypeSchema;
}

export async function getArtifactTypes(): Promise<ArtifactType[]> {
  const response = await api.get('/artifacts/types');
  return response.data;
}
